module.exports = __webpack_public_path__ + "static/media/reducer-switch.7786a0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/reducer-switch.png
// module id = 85
// module chunks = 0